import React, { useState } from 'react'
import { SearchInput } from '@paypalcorp/pp-react'

export const TableSearch = () => {
  const [value, setValue] = useState('')
  const handleChange = (evt: any) => {
    setValue(evt.target.value)
  }
  const handleClear = () => {
    setValue('')
  }

  return (
    <SearchInput
      label="Search"
      name="basic"
      value={value}
      onClear={handleClear}
      onChange={handleChange}
    />
  )
}
